export default __webpack_public_path__ + "static/media/map-green.13884354.svg";